const prompt = {
 
  level1:[
   
    {
        prompt: "旁白：要出發去露營了，背包和行李都還沒有準備好!我們一起來幫忙還有哪些東西要帶呢? 描述句：我忘記帶了一樣長袖的服飾，它是可以穿在身上，它可以讓我們保暖不怕冷，他是套在衣服外面還有拉鍊可以拉起來。正確答案：有拉鍊的長袖外套 錯誤答案1：有鈕扣的短袖上衣 錯誤答案2：有口袋的長褲 錯誤答案3：有口袋的上衣。",
        role1:"答案可以是露營用品，或是旅遊會帶的物品，但是不要是手電筒",
        role2:"描述句的組成必須符合下列規則：第一句:先描述類別，第二句:再來描數外觀特徵，接著第三句:描述功能，最後描述第四句:只有這個物品獨有的特性。",
        example1: "描述句：我忘記帶了一樣長袖的服飾，它是可以穿在身上，它可以讓我們保暖不怕冷，他是套在衣服外面的還有拉鍊可以拉起來。",
        example2: "描述句：我忘記帶了一樣像蓋一樣的東西，它是可以戴在頭上，它可以讓我們遮陽，他是白色的。",
    },
    {
        prompt: "旁白：功課寫完了，我要和我的好朋友一起去公園玩，你在公園有看到什麼東西呢?。 描述句：他是一種遊樂設施，他有樓梯，我們可以爬上去，他還還有一個斜斜的地方。正確答案：溜滑梯 錯誤答案1：盪鞦韆 錯誤答案2：蹺蹺板。",
        role1:"答案必須是公園裡的設施，不會是動物",
        role2:"描述句的組成必須符合下列規則：第一句:先描述類別，第二句:再來描數外觀特徵，接著第三句:描述功能，最後描述第四句:只有這個物品獨有的特性。",
        example1: "描述句：他是一種遊樂設施，他有樓梯，我們可以爬上去，他還還有一個斜斜的地方。",
        example2: "描述句：他是一種遊樂設施，他長長的，他可以坐在上面玩，是兩個人一起玩的設施。",
    },
    {
        prompt: "旁白：來到動物園了，有好多的動物，你知道他們叫什麼名子嗎? 描述句：牠是一種動物，牠全身有很多毛，牠很會爬樹，牠最喜歡吃松果。正確答案：松鼠 錯誤答案1：獅子 錯誤答案2：小狗",
        role1:"答案必須是動物，每個答案的物種要不一樣",
        role2:"描述句的組成必須符合下列規則：第一句:先描述類別，第二句:再來描數外觀特徵，接著第三句:描述內部特色，最後描述第四句:只有這個水果獨有的特性。",
        example1: "描述句：牠是一種動物，牠全身有很多毛，牠很會爬樹，牠最喜歡吃松果。",
        example2: "描述句：牠是一種動物，牠的體型不大，會跳著走路，喜歡吃胡蘿蔔。",
     },
  
   
    
  ],
  level2:[
      {
        preQuestion:"你想要去哪邊玩呢？",
        prompt: "旁白：要出發去露營了，背包和行李都還沒有準備好!我們一起來幫忙還有哪些東西要帶呢? 描述句：我忘記帶了一樣長袖的服飾，它是可以穿在身上，它可以讓我們保暖不怕冷，他是套在衣服外面還有拉鍊可以拉起來。正確答案：有拉鍊的長袖外套 錯誤答案1：有鈕扣的短袖上衣 錯誤答案2：有口袋的長褲。",
        role1:"答案是旅遊會帶的物品",
        role2:"描述句的組成必須符合下列規則：第一句:先描述類別，第二句:再來描數外觀特徵，接著第三句:描述功能，最後描述第四句:只有這個物品獨有的特性。",
        example1: "描述句：我忘記帶了一樣長袖的服飾，它是可以穿在身上，它可以讓我們保暖不怕冷，他是套在衣服外面的還有拉鍊可以拉起來。",
        example2: "描述句：我忘記帶了一樣像蓋一樣的東西，它是可以戴在頭上，它可以讓我們遮陽，他是白色的。",
      },
      {
        preQuestion:"你想要去哪裡的公園玩呢？",
        prompt: "旁白：功課寫完了，我要和我的好朋友一起去公園玩，你在公園有看到什麼東西呢?。 描述句：他是一種遊樂設施，他有樓梯，我們可以爬上去，他還有一個斜斜的地方。正確答案：溜滑梯 錯誤答案1：盪鞦韆 錯誤答案2：蹺蹺板。",
        role1:"答案必須是公園裡的設施，不會是動物。",
        role2:"描述句的組成必須符合下列規則：第一句:先描述類別，第二句:再來描數外觀特徵，接著第三句:描述功能，最後描述第四句:只有這個物品獨有的特性。",
        example1: "描述句：他是一種遊樂設施，他有樓梯，我們可以爬上去，他還有一個斜斜的地方。",
        example2: "描述句：他是一種遊樂設施，他長長的，他可以坐在上面玩，是兩個人一起玩的設施。",
      },
      {
        preQuestion:"你想知道哪裡的動物呢？",
        prompt: "旁白：來到動物園了，有好多的動物，你知道他們叫什麼名子嗎? 描述句：牠是一種動物，牠全身有很多毛，牠很會爬樹，牠最喜歡吃松果。正確答案：松鼠 錯誤答案1：獅子 錯誤答案2：小狗",
        role1:"答案必須是動物，每個答案的物種要不一樣",
        role2:"描述句的組成必須符合下列規則：第一句:先描述類別，第二句:再來描數外觀特徵，接著第三句:描述內部特色，最後描述第四句:只有這個水果獨有的特性。",
        example1: "描述句：牠是一種動物，牠全身有很多毛，牠很會爬樹，牠最喜歡吃松果。",
        example2: "描述句：牠是一種動物，牠的體型不大，會跳著走路，喜歡吃胡蘿蔔。",
      },
    
    

  ],
  
  



    

    
   


  
    
  
  
};
module.exports = prompt ;
